<div class="px-4" data-cy="dlg-confirm">
    <h5 class="text-center mt-5 mb-4" data-cy="comment-dialog-title">
        {{ data?.title }}
    </h5>
    <div class="d-flex flex-column pb-3 mb-3">
        <div class="dialog-body m-3">
            @for (line of data?.bodyText; track $index) {
                <div>{{ line }}</div>
            }
        </div>
        <form [formGroup]="commentForm">
            <clmi-comment-input-box
                (commentUpdated)="commentUpdated($event)"
                class="my-2 mx-5 px-2"
            ></clmi-comment-input-box>
            <wdx-multi-select
                [options]="rejectionReasons$ | ngrxPush"
                [formControlNameOrIndex]="'reason'"
                [multiple]="false"
                [searchable]="false"
            ></wdx-multi-select>
        </form>
    </div>
    <div class="d-flex align-items-center justify-content-center">
        <div class="dialog-footer mt-4 mb-5">
            <button class="btn" data-cy="btn-no" (click)="cancel()">
                Cancel
            </button>
            <button
                class="btn btn-danger ms-4"
                data-cy="btn-yes"
                (click)="confirm()"
                [disabled]="!commentForm.valid || !commentCreate?.content"
            >
                Confirm
            </button>
        </div>
    </div>
</div>
